/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable no-script-url */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import PrintHelper from 'print-helper-lib';
import TransactionGridComponent from './TransactionGridComponent';
import TransactionGridComponentMobile from './TransactionGridComponentMobile';
import { SubsectionHeading } from 'web-ui-components/lib/typography/headings';
import BrowserUtils from '../../../utils/BrowserUtils';

class TransactionsDetailsPerAccountComponent extends React.Component {
  getConsolidatedAccountList() {
    const { poolDetails, allAccounts } = this.props;

    const consolidatedAccountList = poolDetails.accounts.map((account) => {
      const fullAccountDetails = allAccounts.find(
        (acc) => acc.id === account.accountId
      );

      if (!fullAccountDetails)
        return {
          accountId: account.accountId,
          accountDisplayName: '',
          accountNumber: '',
        };

      const {
        number,
        metadata: { account_name, display_name },
        product: { name },
      } = fullAccountDetails;

      const accountDisplayName = display_name || account_name || name;

      return {
        accountId: account.accountId,
        accountDisplayName,
        accountNumber: number,
      };
    });

    return consolidatedAccountList;
  }

  chunkTransactionsPerAccount(consolidatedAccountList) {
    const { transactions } = this.props;

    return consolidatedAccountList.map((account) =>
      transactions.filter(
        (transaction) => transaction.accountId === account.accountId
      )
    );
  }

  loadNextTransactions(accountIdx) {
    const accountId = this.props.poolDetails.accounts[accountIdx].accountId;

    this.props.loadNextTransactions(accountId);
  }

  renderAccountTransactionTables() {
    const consolidatedAccountList = this.getConsolidatedAccountList();
    const transactionsPerAccount = this.chunkTransactionsPerAccount(
      consolidatedAccountList
    );

    const TransactionGrid = !BrowserUtils.isTabletView()
      ? TransactionGridComponent
      : TransactionGridComponentMobile;

    const tables = transactionsPerAccount.map((transactions, idx) => (
      <span key={`${consolidatedAccountList[idx].accountId}-transactions`}>
        <SubsectionHeading>{`Account ${idx + 1} ${
          consolidatedAccountList[idx].accountDisplayName
        } ${consolidatedAccountList[idx].accountNumber}`}</SubsectionHeading>
        <TransactionGrid
          {...this.props}
          transactionReadFlag={this.props.transactionReadFlag}
          selectedRowIds={this.props.selectedRowIds}
          isLoading={this.props.isLoading}
          data={transactions}
          loadNextTransactions={() => this.loadNextTransactions(idx)}
          onSort={this.props.onSort}
          loadTransactionsFlag={this.props.loadTransactionsFlag} //maybe needed as well
          onRowClick={this.props.onRowClick}
          isMultipleSelection={this.props.isMultipleSelection}
          onRowSelect={this.props.onRowSelect}
          onRowSelectAll={this.props.onRowSelectAll}
          rowCustomClass={this.props.rowCustomClass}
          rowClickIndex={this.props.rowClickIndex}
          onTableTagClick={this.props.onTableTagClick}
          openTransactionInProgressPopUp={
            this.props.openTransactionInProgressPopUp
          }
          transactionServiceErrorFlag={this.props.transactionServiceErrorFlag}
          transactionServiceErrorMessage={
            this.props.transactionServiceErrorMessage
          }
          statusErrorResponse={this.props.statusErrorResponse}
          onRetryClick={this.props.onRetryClick}
        />
      </span>
    ));

    return <span>{tables}</span>;
  }

  render() {
    const { poolDetails } = this.props;
    if (!poolDetails) return null;

    return this.renderAccountTransactionTables();
  }
}
TransactionsDetailsPerAccountComponent.propTypes = {
  accDetails: PropTypes.any,
  account: PropTypes.string,
  accountChangeFlag: PropTypes.any,
  accountIdFromStore: PropTypes.any,
  accountType: PropTypes.any,
  changeOfDate: PropTypes.any,
  content: PropTypes.object,
  endDate: PropTypes.any,
  fromChangeOfDate: PropTypes.any,
  getSelectedTypeTransactions: PropTypes.func,
  isAccountPool: PropTypes.bool,
  isLoading: PropTypes.bool,
  isMultipleSelection: PropTypes.bool,
  isPopUpOpen: PropTypes.bool,
  loadNextTransactions: PropTypes.func,
  loadTransactionsFlag: PropTypes.bool,
  mobileSelectionTag: PropTypes.func,
  monthName: PropTypes.any,
  onDateChange: PropTypes.func,
  onRetryClick: PropTypes.any,
  onRowClick: PropTypes.func,
  onRowSelect: PropTypes.func,
  onRowSelectAll: PropTypes.any,
  onSort: PropTypes.func,
  onTableTagClick: PropTypes.func,
  onTableTagIconClick: PropTypes.any,
  openTransactionInProgressPopUp: PropTypes.any,
  rowClickIndex: PropTypes.any,
  rowCustomClass: PropTypes.any,
  selectedRowIds: PropTypes.array,
  settingFromDate: PropTypes.any,
  settingMonthName: PropTypes.any,
  settingToDate: PropTypes.any,
  showMoreLoader: PropTypes.bool,
  showMoreLoaderFlag: PropTypes.any,
  showSelectionTag: PropTypes.bool,
  startDate: PropTypes.any,
  suggestData: PropTypes.array,
  tabSelect: PropTypes.func,
  transactionReadFlag: PropTypes.bool,
  transactionServiceErrorFlag: PropTypes.any,
  transactionServiceErrorMessage: PropTypes.any,
  statusErrorResponse: PropTypes.any,
  transactions: PropTypes.array,
  transactionsLoading: PropTypes.bool,
};

TransactionsDetailsPerAccountComponent.defaultProps = {
  onSort: () => {},
  transactionsLoading: false,
};

export default TransactionsDetailsPerAccountComponent;
